"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyDiff = exports.diffItems = exports.splitChanges = exports.ChangeType = void 0;
const lodash_1 = require("lodash");
const unique_1 = require("./unique");
var ChangeType;
(function (ChangeType) {
    ChangeType["Addition"] = "A";
    ChangeType["Update"] = "U";
    ChangeType["Delete"] = "D";
    ChangeType["Reorder"] = "R";
})(ChangeType || (exports.ChangeType = ChangeType = {}));
function splitChanges(changes) {
    return (0, lodash_1.groupBy)(changes, 'type');
}
exports.splitChanges = splitChanges;
function diffItems(from, to, { order } = {}) {
    const dFrom = (0, unique_1.mergeDuplicateItems)(from);
    const dTo = (0, unique_1.mergeDuplicateItems)(to);
    const added = dTo.filter(item => !dFrom.some(f => f.id === item.id)) || [];
    const removed = dFrom.filter(item => !dTo.some(t => t.id === item.id)) || [];
    const changed = dTo.filter(item => {
        const fromItem = dFrom.find(f => f.id === item.id);
        return fromItem !== null && fromItem !== undefined && !(0, lodash_1.isEqual)(item, fromItem);
    }) || [];
    let reorderItem = undefined;
    if (order) {
        const orderChanged = dTo.some((item, index) => {
            const fromItem = dFrom[index];
            return fromItem !== null && fromItem !== undefined && fromItem.id !== item.id;
        });
        if (orderChanged) {
            reorderItem = {
                type: ChangeType.Reorder,
                sortedIds: dTo.map(item => item.id),
            };
        }
    }
    return [
        ...added.map(add => ({
            type: ChangeType.Addition,
            item: add,
        })),
        ...changed.map(change => ({
            type: ChangeType.Update,
            item: change,
        })),
        ...removed.map(remove => ({
            type: ChangeType.Delete,
            id: remove.id,
        })),
        ...(reorderItem ? [reorderItem] : []),
    ];
}
exports.diffItems = diffItems;
function applyDiff(existing, changes) {
    const realExisting = (0, unique_1.mergeDuplicateItems)(existing);
    const { A: additions, D: deletions, U: updates, R: reorder } = splitChanges(changes || []);
    const result = realExisting
        .filter(existingItem => !(deletions === null || deletions === void 0 ? void 0 : deletions.some(deletion => deletion.id === existingItem.id)))
        .map(existingItem => {
        const update = updates === null || updates === void 0 ? void 0 : updates.find(update => update.item.id === existingItem.id);
        return update ? update.item : existingItem;
    });
    for (const addition of additions || []) {
        const existingIndex = result.findIndex(item => item.id === addition.item.id);
        if (existingIndex !== -1) {
            result[existingIndex] = addition.item;
        }
        else {
            result.push(addition.item);
        }
    }
    if (reorder === null || reorder === void 0 ? void 0 : reorder.length) {
        if (reorder.length !== 1)
            throw new Error('There can only be 1 reorder item when applying a diff.');
        const { sortedIds } = reorder[0];
        return sortedIds.map(id => result.find(item => item.id === id)).filter(Boolean);
    }
    else
        return result;
}
exports.applyDiff = applyDiff;
//# sourceMappingURL=diff.js.map